import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 21,
	viewBox: "0 0 21 21",
	width: 21,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		strokeWidth: .7,
		fillRule: "evenodd",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		transform: "translate(4 3)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "m9.221 4.716.165 5.821-5.792-.135",
				transform: "matrix(-.70710678 .70710678 .70710678 .70710678 5.685139 -2.354861)"
			}),
			/* @__PURE__ */ _jsx("path", { d: "m6.5.5v11" }),
			/* @__PURE__ */ _jsx("path", { d: "m.5 14.5h12" })
		]
	})
});
export default SvgDownload;
